<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-md-12 mb-5">
        <div>
          <step-progress
            :steps="mySteps"
            :current-step="currentStep"
            icon-class="fa fa-check"
            active-color="#c698fa"
          ></step-progress>
        </div>
      </div>
      <div class="col-md-12 ">
        <h3>Select Type:</h3>
        <div
          class=""
          v-if="!loading"
        >
          <b-card-group deck>
            <b-card
              class="text-center"
              :class="{ active: selectType === index }"
              bg-variant="light"
              v-for="(item, index) in packageArr"
              :key="index"
            >
              <b-card-title>{{ getPackageTypeFull(index) }}</b-card-title>
              <b-card-text></b-card-text>

              <template v-slot:footer>
                <b-button
                  variant="secondary"
                  @click="packageTypeClick(index)"
                >Select</b-button>
              </template>
            </b-card>
          </b-card-group>
        </div>
        <div
          v-else
          class="text-center my-2"
        >
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </div>

      <!-- Children Duration -->

      <div
        class="col-md-12 mt-4 package_duration"
        v-if="selectType == index"
        v-for="(item, index) in packageArr"
        :key="index"
      >
        <h3>Select Duration:</h3>
        <div class="">
          <b-card-group deck>
            <b-card
              class="text-center"
              :class="{
                active:
                  selectDuration === packageArr[index][childindex].duration,
              }"
              bg-variant="light"
              v-for="(childitem, childindex) in packageArr[index]"
              :key="childindex"
            >
              <b-card-title>{{
                getPackageDurationFull(packageArr[index][childindex].duration)
              }}</b-card-title>
              <b-card-text></b-card-text>

              <template v-slot:footer>
                <b-button
                  class="btn btn-sm"
                  variant="secondary"
                  @click="
                    packageDurationClick(
                      packageArr[index][childindex].duration,
                      packageArr[index][childindex].id
                    )
                  "
                >Select</b-button>
              </template>
            </b-card>
          </b-card-group>
        </div>
      </div>

      <!-- End of Children Duration -->
    </div>
    <div
      class="mt-4 d-flex justify-content-center"
      v-if="selectType != null && selectDuration != null"
    >
      <b-button
        size="lg"
        block
        variant="primary"
        @click.prevent="PackageSubmit"
      >Next</b-button>
    </div>
  </div>
</template>
<script>
import {
  packageTypeFull,
  packageDurationAbbri
} from "./../js/utils/datamanip.js";

import StepProgress from "vue-step-progress";
import "vue-step-progress/dist/main.css";
export default {
  data() {
    return {
      mySteps: ["Package", "Member", "Payment", "Complete"],
      currentStep: 0,
      selectType: null,
      selectDuration: null,
      packageArr: {},
      loading: true
    };
  },
  components: {
    "step-progress": StepProgress
  },
  computed: {},
  mounted() {
    this.loadPackage();
  },
  methods: {
    async loadPackage() {
      this.loading = true;
      await axios
        .get("/api/packages/list")
        .then(response => {
          //console.log("len " + response.data.data.length);
          //console.log(response.data);

          for (const key in response.data) {
            let item = response.data[key];

            if (this.packageArr[item.type] == null) {
              this.packageArr[item.type] = {};
            }
            if (this.packageArr[item.type][item.duration] == null) {
              this.packageArr[item.type][item.duration] = {};
            }

            this.packageArr[item.type][item.duration] = {
              id: item.id,
              type: item.type,
              duration: item.duration,
              price: item.price,
              price_student: item.price_student,
              price_staff: item.price_staff,
              price_public: item.price_public,
              period: item.period,
              session_max: item.session_max
            };
            //console.log(Key + " " + response.data[key]);
          }
          //console.log(this.packageArr);
        })
        .catch(function(error) {
          //console.log(error.response.data.errors);
          //if(error.response.data.errors.message =)
        })
        .finally(() => (this.loading = false));
    },
    packageTypeClick(type) {
      this.selectType = type;

      this.selectDuration = null;
    },
    packageDurationClick(duration, id) {
      this.selectDuration = duration;
      this.selectID = id;
    },
    PackageSubmit() {
      /* this.$store.dispatch("setSalePackage", {
        id: this.selectID,
        type: this.selectType,
        duration: this.selectDuration,
        price: this.
      }); */
      this.$store.dispatch(
        "setSalePackage",
        this.packageArr[this.selectType][this.selectDuration]
      );

      this.$store.dispatch("setSaleState", 1);
    },
    getPackageTypeFull(key) {
      return packageTypeFull[key];
    },
    getPackageDurationFull(key) {
      return packageDurationAbbri[key];
    }
  }
};
</script>
<style scoped>
.active {
  background-color: #c698fa !important;
}
.package_duration .card-title {
  font-size: 1.1rem;
}
</style>
